import { makeRequest } from 'utils/requestLogger';

export default (id) => makeRequest('get', `/api/live_discussions/${id}`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/loadLiveDiscussion.js